import _ from 'lodash'

import {
  CLEAR_COMMENT_ERRORS_SUCCESS,
  CREATE_COMMENT_FAILURE,
  CREATE_COMMENT_SUCCESS,
  LIST_COMMENTS_FAILURE,
  LIST_COMMENTS_SUCCESS,
  SET_COMMENT_ERRORS_SUCCESS
} from '../actions/comment'

const comment = (state = {}, action) => {
  switch (action.type) {
    case CREATE_COMMENT_SUCCESS:
      return state
    case LIST_COMMENTS_SUCCESS:
      return {
        ...state,
        list: action.data.list
      }
    case SET_COMMENT_ERRORS_SUCCESS:
      return {
        ...state,
        ...action.data
      }
    case CLEAR_COMMENT_ERRORS_SUCCESS:
      return _.omit(state, 'errors')
    case CREATE_COMMENT_FAILURE:
    case LIST_COMMENTS_FAILURE:
    default:
      return state
  }
}

export default comment


// WEBPACK FOOTER //
// ./src/reducers/comment.js